import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import localeSv from '@angular/common/locales/sv'

import {ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar'
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {LOCAL_STORAGE, WINDOW} from './application/app'
import {authInterceptor} from './application/auth-interceptor'
import {HOME_ROUTE_PATH, IS_LANDING_ADMIN_ROLE} from './application/data-types'

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [IS_LANDING_ADMIN_ROLE]
}

registerLocaleData(localeFr, 'fr')
registerLocaleData(localeSv)
export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till Landing App, för att komma igång måste du logga in med BankID.',
        buttonText: 'Logga in med BankID',
        title: 'Landing App',
        route: ['/', HOME_ROUTE_PATH]
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {provide: WINDOW, useValue: window},
    {
      provide: LOCAL_STORAGE,
      useFactory: () => localStorage
    },
    provideZonelessChangeDetection(),
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline'
      }
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        horizontalPosition: 'center',
        verticalPosition: 'top'
      }
    },
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv},
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, responseInterceptor])),
    provideRouter(
      routes,
      withHashLocation(),
      withInMemoryScrolling({anchorScrolling: 'enabled'})
    )
  ]
}